import asyncActionTypes from '../actions/types.js';

const initialState = {};

const openModalLogin = (state = initialState, action) => {
  if (action.type === asyncActionTypes.OPEN_MODAL_LOGIN.SUCCESS) {
    return {
      ...state,
      sourceOpenModalLogin: action.payload,
    };
  } else {
    return state;
  }
};

const modalLoginMethod = (state = initialState, action) => {
  if (action.type === asyncActionTypes.OPEN_MODAL_LOGIN_METHOD.SUCCESS) {
    return {
      ...state,
      loginMethod: action.payload,
    };
  } else {
    return state;
  }
};

export { openModalLogin, modalLoginMethod };